import { getCurrentInstance } from 'vue';

export function useToasted() {
    const app = getCurrentInstance();

    return app.appContext.config.globalProperties.$toasted;
}
